import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import { Row, Col } from 'react-bootstrap';
import {  Typography ,Button , TextField} from '@material-ui/core';
import { withRouter } from 'react-router';

import Logo from '../../../images/logo.png';

class  ForgetPassword extends Component{
    constructor(){
        super();
        this.state = {
            email : '',
            errorMessage : '',
            to : '/resetPassword',
            from : '/forgetPassword',
        }
    }
    render(){
    const handleChangeEmail = prop => event => {
        this.setState({ ...this.state, [prop]: event.target.value });
    };
    const ValidateEmail = (mail) =>
    {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
        {
            this.setState({ ...this.state, errorMessage : ''});
            return (true)
        }
        this.setState({ ...this.state, errorMessage : 'You have entered an invalid email address!' });
        return (false)
    }
    return (
            <div className="container-custom pt-10">
                <form 
                    onSubmit={e => {
                        e.preventDefault();
                        if(ValidateEmail(this.state.email)){
                            this.props.mutate({
                                variables : {
                                    email : this.state.email,
                                }
                            }).then((res)=>{
                                if(res.data.sendPinCodeForpasswordresets.Status.code === 200){
                                    this.props.history.push({
                                        pathname: '/emailConfirmation',
                                        state: {    
                                            email : this.state.email,
                                            to    : this.state.to,
                                            from  : this.state.from
                                            }
                                      });
                                }
                                else {
                                    this.setState({...this.state, errorMessage : res.data.sendPinCodeForpasswordresets.RequestStatus.messageLog});
                                }
                            })
                            .catch((err)=> 
                            this.setState({...this.state, errorMessage : "Email is not valid"}));
                         }
                        }}
                 className="container" autoComplete="off">
                    <div className="pt-1 pb-3">
                        <img src={Logo} alt="spreago logo" width="150px"/>
                    </div>
                    <div className="pb-3">
                        <Typography variant="h4" color="primary" >Reset your password</Typography>
                    </div>
                    <div className="pt-1 pb-3">
                        <Typography variant="subtitle1" className="text-dark">Please enter your email address and we will send you a confirmation email to your inbox</Typography>
                    </div>
                    <div className="pt-4">
                    <TextField
                             required
                            fullWidth
                            type = "email"
                            label="Email"
                            color="primary"
                            variant="outlined"
                            value={this.state.email}
                            onChange={handleChangeEmail('email')}
                        />
                    </div>
                    <Row className="pt-3">
                    <Col xs={12}>
                            <div className="text-danger"><p>{this.state.errorMessage}</p></div>
                        </Col>
                        <Col xs={12} className="text-center">
                            <Button size="large" variant="contained" className="btn-orange-gradiant pr-5 pl-5" type="submit" color="primary"><Typography>Continue</Typography></Button>
                        </Col>
                    </Row>
                  
                </form>
            </div>
    );
 }
}
const SEND_CODE = gql`
  mutation( $email : Email! ){
    sendPinCodeForpasswordresets(email: $email){
      RequestStatus{
        messageLog
        codeLog
      }
      Status{
        code
      }
    }
  }
`;
export default graphql(SEND_CODE)(withRouter(ForgetPassword));
